import {
  UPDATE_FORM_VALUES,
  UPDATE_FORM_SUCCESS,
  RESET_FORM,
  RESET_FORM_SUCCESS,
  SUBMIT_FORM_SUCCESS,
  SET_FIELD_VALUE,
  SET_FIELD_VALUE_SUCCESS,
  GET_FORM_VALUES,
  GET_FORM_VALUES_SUCCESS,
  ADD_DYNAMIC_FORM,
  DELETE_DYNAMIC_FORM
} from './'
import { formList } from './formList'
import { formList as formList_employer } from '../form/employer/formList'
import { employerSide } from '../routerHistory'

const formListValue = employerSide ? formList_employer : formList

const initialState = formListValue.reduce(
  (obj, key) => ({
    ...obj,
    [key]: {
      loadData: {},
      values: {},
      setValue: null,
      shouldLoad: false,
      shouldReset: false,
      shouldGetValues: false,
      updatedFormSuccess: false
    }
  }),
  {}
)

const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FORM_VALUES:
      return Object.assign(
        {},
        { ...state },
        {
          [action.form]: {
            ...state[action.form],
            loadData: action.values,
            shouldLoad: true,
            updatedFormSuccess: false
          }
        }
      )

    case UPDATE_FORM_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          [action.form]: {
            ...state[action.form],
            shouldLoad: false,
            updatedFormSuccess: true
          }
        }
      )

    case RESET_FORM:
      return Object.assign(
        {},
        { ...state },
        {
          [action.form]: {
            ...state[action.form],
            shouldReset: true,
            updatedFormSuccess: false
          }
        }
      )

    case RESET_FORM_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          [action.form]: {
            ...state[action.form],
            loadData: {},
            values: {},
            shouldReset: false,
            updatedFormSuccess: true
          }
        }
      )

    case SUBMIT_FORM_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          [action.form]: {
            ...state[action.form],
            values: action.values
          }
        }
      )

    case GET_FORM_VALUES:
      return Object.assign(
        {},
        { ...state },
        {
          [action.form]: {
            ...state[action.form],
            shouldGetValues: true
          }
        }
      )

    case GET_FORM_VALUES_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          [action.form]: {
            ...state[action.form],
            shouldGetValues: false,
            values: action.values
          }
        }
      )

    case SET_FIELD_VALUE:
      return Object.assign(
        {},
        { ...state },
        {
          [action.form]: {
            ...state[action.form],
            setValue: action.field
          }
        }
      )

    case SET_FIELD_VALUE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          [action.form]: {
            ...state[action.form],
            setValue: null
          }
        }
      )

    case ADD_DYNAMIC_FORM:
      return Object.assign(
        {},
        { ...state },
        {
          [action.name]: {
            loadData: {},
            values: {},
            setValue: null,
            shouldLoad: false,
            shouldReset: false
          }
        }
      )

    case DELETE_DYNAMIC_FORM:
      const { [action.name]: deleted, ...rest } = state
      if (deleted) {
        return rest
      } else return state

    default:
      return state
  }
}

export default formReducer
